/* Only the coffee-brand picker needs JS. Product links, anchors and disclosures are native HTML. */
(() => {
  if (customElements.get('sokit-fit-finder')) return;
  customElements.define('sokit-fit-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-fit-enhanced')) return;
      const select = this.querySelector('[data-fit-select]');
      const control = this.querySelector('[data-fit-control]');
      const panels = [...this.querySelectorAll('[data-fit-brand]')];
      if (!select || !control || !panels.length) return;
      const update = () => {
        for (const panel of panels) {
          const active = panel.dataset.fitBrand === select.value;
          panel.hidden = !active;
          panel.open = active;
        }
      };
      select.addEventListener('change', update);
      /* Reordering or selecting a brand block in Shopify's editor reveals its panel. */
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-fit-brand]');
        if (panel && this.contains(panel)) {
          select.value = panel.dataset.fitBrand;
          update();
        }
      });
      update();
      this.setAttribute('data-fit-enhanced', '');
      control.hidden = false;
    }
  });
})();
